import React from 'react';

export const CallBackIcon = ({ width = 14, height = 14, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.9165 2.92057C2.76179 2.92057 2.61342 2.98203 2.50402 3.09143C2.39816 3.19729 2.33719 3.33966 2.33336 3.48895C2.46752 5.61458 3.37243 7.61858 4.8788 9.12494C6.38517 10.6313 8.38917 11.5362 10.5148 11.6704C10.6641 11.6666 10.8064 11.6056 10.9123 11.4997C11.0217 11.3903 11.0832 11.2419 11.0832 11.0872V9.14884L8.99445 8.31335L8.37504 9.3457C8.21885 9.60602 7.88909 9.70302 7.61682 9.56874C6.23494 8.88722 5.11652 7.76881 4.435 6.38692C4.30072 6.11465 4.39772 5.7849 4.65805 5.6287L5.69039 5.0093L4.8549 2.92057H2.9165ZM1.67907 2.26647C2.00726 1.93828 2.45238 1.75391 2.9165 1.75391H5.24984C5.48836 1.75391 5.70286 1.89913 5.79145 2.12059L6.95811 5.03726C7.06445 5.3031 6.96214 5.6068 6.71663 5.75411L5.74013 6.34001C6.22071 7.12379 6.87995 7.78303 7.66373 8.26362L8.24963 7.28712C8.39694 7.04161 8.70065 6.93929 8.96648 7.04563L11.8831 8.21229C12.1046 8.30088 12.2498 8.51538 12.2498 8.75391V11.0872C12.2498 11.5514 12.0655 11.9965 11.7373 12.3247C11.4091 12.6529 10.964 12.8372 10.4998 12.8372C10.488 12.8372 10.4762 12.8369 10.4645 12.8362C8.04681 12.6892 5.76653 11.6626 4.05384 9.9499C2.34116 8.23722 1.3145 5.95693 1.16758 3.53929C1.16686 3.52751 1.1665 3.51571 1.1665 3.50391C1.1665 3.03978 1.35088 2.59466 1.67907 2.26647Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.079 1.92476C12.3068 2.15257 12.3068 2.52191 12.079 2.74972L9.16232 5.66639C8.93451 5.89419 8.56516 5.89419 8.33736 5.66639C8.10955 5.43858 8.10955 5.06923 8.33736 4.84143L11.254 1.92476C11.4818 1.69695 11.8512 1.69695 12.079 1.92476Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.74984 2.3285C9.072 2.3285 9.33317 2.58967 9.33317 2.91184V4.66184H11.0832C11.4053 4.66184 11.6665 4.92301 11.6665 5.24517C11.6665 5.56734 11.4053 5.8285 11.0832 5.8285H8.74984C8.42767 5.8285 8.1665 5.56734 8.1665 5.24517V2.91184C8.1665 2.58967 8.42767 2.3285 8.74984 2.3285Z"
      fill="currentColor"
    />
  </svg>
);
